/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { RemoteStageSummary } from './remoteStageSummary';
import type { ShapeDiff } from './shapeDiff';

/**
 * Read-only check: map and/or shape-ack required before linking?
 */
export interface LinkStageMapPreviewResponse {
  required: boolean;
  occupied_stage_ids?: string[];
  remote_stages?: RemoteStageSummary[];
  shape_mismatch?: boolean;
  shape_diff?: ShapeDiff;
  path: string;
}
